import { I18nextProvider } from 'react-i18next';
import { Provider } from 'react-redux';
import React, { Suspense } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { MuiProviders } from 'common/mui/mui-providers';
import { ApolloClientProvider } from 'common/apollo/index';
import i18n from '~settings/i18n';
import store from '~client/store';
import Router from '~pages/router';

const App = () => {
  return (
    <MuiProviders>
      <Provider store={store}>
        <I18nextProvider i18n={i18n}>
          <BrowserRouter basename={process.env.PUBLIC_URL}>
            <Suspense fallback="">
              <ApolloClientProvider>
                <Router />
              </ApolloClientProvider>
            </Suspense>
          </BrowserRouter>
        </I18nextProvider>
      </Provider>
    </MuiProviders>
  );
};

export default App;
